import { jsxs as s, jsx as l } from "react/jsx-runtime";
import { useState as f, useEffect as p } from "react";
import i from "./carousel.module.less.js";
import P from "embla-carousel-react";
import { OutlineIconButton as u } from "../button/button.js";
import { useTranslation as _ } from "react-i18next";
const k = ({ heading: t, items: S, wrapperClassName: n }) => {
  const [a, h] = f(!1), [c, v] = f(!1), [N, e] = P({
    slidesToScroll: "auto",
    align: "start"
  }), r = (o) => {
    o && (h(o.canScrollPrev()), v(o.canScrollNext()));
  };
  p(() => {
    if (e)
      return r(e), e?.on("reInit", r), e?.on("select", r), () => {
        e?.off("select", r);
      };
  }, [e, r]);
  const { t: m } = _(), d = a || c;
  return /* @__PURE__ */ s("div", { className: [i.wrapper, n || ""].join(" "), children: [
    t && /* @__PURE__ */ l("h2", { children: t }),
    /* @__PURE__ */ s("div", { className: "embla", children: [
      /* @__PURE__ */ l("div", { ref: N, className: "embla__viewport", children: /* @__PURE__ */ l("ul", { className: [i.slider, "embla__container", d ? "" : i.hidePeek].join(" "), children: S.map((o, b) => /* @__PURE__ */ l("li", { className: ["embla__slide", i.slide].join(" "), children: o }, b)) }) }),
      d && /* @__PURE__ */ s("div", { className: i.navigation, children: [
        /* @__PURE__ */ l(
          u,
          {
            isDisabled: !a,
            icon: "ui-icon-arrow-left",
            onClick: () => e?.scrollPrev(),
            ariaLabel: m("PREVIOUS_PAGE")
          }
        ),
        /* @__PURE__ */ l(
          u,
          {
            isDisabled: !c,
            icon: "ui-icon-arrow-right",
            onClick: () => e?.scrollNext(),
            ariaLabel: m("NEXT_PAGE")
          }
        )
      ] })
    ] })
  ] });
};
export {
  k as Carousel,
  k as default
};
